import React, {useState} from 'react';
import {NavLink} from 'react-router';
import {ReactComponent as Left} from '../../assets/icons/arrow-left.svg';
import PrivateNavLinks from './PrivateNavLinks';
import {useUser} from '../../Providers/UserInfo';

export default function Sidebar() {
    const [open, setOpen] = useState(true);
    const {name} = useUser();

    return (
        <aside
            className={`rest-panel-sidebar hidden lg:flex ${open ? 'rest-panel-sidebar--open' : 'rest-panel-sidebar--collapsed'}`}
        >
            <div className="rest-panel-sidebar__accent" aria-hidden="true"/>

            <div className="rest-panel-sidebar__top">
                <button
                    type="button"
                    onClick={() => setOpen((v) => !v)}
                    className={`rest-panel-sidebar__toggle ${open ? 'rest-panel-sidebar__toggle--open' : ''}`}
                    aria-label={open ? 'جمع کردن منو' : 'باز کردن منو'}
                >
                    <Left/>
                </button>
            </div>

            <NavLink to="/orders" className="rest-panel-sidebar__brand">
                <img
                    src="/images/small-logo.png"
                    alt="غذارسان"
                    className="rest-panel-sidebar__logo"
                    width={40}
                    height={40}
                />
                {open && (
                    <div className="rest-panel-sidebar__brand-text">
                        <span className="rest-panel-sidebar__brand-name">غذارسان</span>
                        <span className="rest-panel-sidebar__brand-sub">پنل رستوران</span>
                    </div>
                )}
            </NavLink>

            {open && name && (
                <p className="rest-panel-sidebar__restaurant">{name}</p>
            )}

            <PrivateNavLinks collapsed={!open}/>
        </aside>
    );
}
